import React, { useState, Context, ReactElement, Component } from "react";
import Cookies from "universal-cookie";
import {set_lang_cookie} from '../components/top-navbar/top-navbar';

const cookies = new Cookies();

const cookie_lang = cookies.get("lang");
let language = cookie_lang;
if (!cookie_lang) {
  language = ['zh-CN', 'zh-TW', 'en-US'].includes(navigator.language) ? navigator.language : 'en-US';
  set_lang_cookie(language);
}

const LangContext: Context<[string, React.Dispatch<React.SetStateAction<string>>]> = React.createContext<
  [string, React.Dispatch<React.SetStateAction<string>>]
>(["", (_value: any) => { }]);

const LangProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (
  props: any
): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [lang, set_lang]: [string, React.Dispatch<React.SetStateAction<string>>] = useState(language);
  return <LangContext.Provider value={[lang, set_lang]}>{props.children}</LangContext.Provider>;
};

export { LangContext, LangProvider };
